document.addEventListener('DOMContentLoaded', () => {

  const menuBtns = document.querySelectorAll('.menu-btn');
  const drops = document.querySelectorAll('.dropdown');

  menuBtns.forEach(el => {
    el.addEventListener('click', (e) => {
      let currentBtn = e.currentTarget;
      let drop = currentBtn.closest('.menu-item').querySelector('.dropdown');

      menuBtns.forEach(el => {
        if (el !== currentBtn) {
          el.classList.remove('menu-btn--active');
        }
      });

      drops.forEach(el => {
        if (el !== drop) {
          el.classList.remove('dropdown--active');
        }
      });

      drop.classList.toggle('dropdown--active');
      currentBtn.classList.toggle('menu-btn--active');
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.menu')) {
      menuBtns.forEach(el => {
        el.classList.remove('menu-btn--active');
      });

      drops.forEach(el => {
        el.classList.remove('dropdown--active');
      });
    }
  });
});


 const roleButtons = document.querySelectorAll('.modal__form-role-btn');

  roleButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Удалить класс 'active' у всех
      roleButtons.forEach(btn => btn.classList.remove('active'));
      // Добавить класс 'active' только на нажатую кнопку
      button.classList.add('active');
    });
  });
